import {
  ReactNode, useEffect, useMemo, useState
} from "react";
import { useDispatch } from "react-redux";

import { uiSetConfigurationReady } from "Store/Actions";
import { Configuration } from "Utils/Configuration";
import { ConfigurationContext } from "./ConfigurationContext";

export interface ITranslationProviderProps {
  children: ReactNode;
}

export function ConfigurationProvider(props: ITranslationProviderProps): JSX.Element {
  const [instance, setInstance] = useState<Configuration>(null);
  const dispatch = useDispatch();
  const promise = useMemo(() => Configuration.getInstanceAsync(), []);

  useEffect(() => {
    promise.then((result) => {
      setInstance(result);
      dispatch(uiSetConfigurationReady());
    });
  }, [promise, dispatch]);

  if (!instance?.isInitialized ?? false) {
    return null;
  }

  const { children } = props;
  return <ConfigurationContext.Provider value={instance}>{children}</ConfigurationContext.Provider>;
}
